export const downloadApp = () => {
  window.location.replace("https://chowcentral.onelink.me/bvtE/t8dfjd86");
};

export const openApp = (store?: "play" | "app") => {
  const iosStore = "https://apps.apple.com/ng/app/500chow/id1661689494";
  const androidStore =
    "https://play.google.com/store/apps/details?id=com.chowcentral";
  const isIOS = /iPhone|iPad|iPod/.test(navigator.userAgent);
  const isAndroid = /Android/.test(navigator.userAgent);

  if (store === "play") {
    return (window.location.href = androidStore);
  } else if (store === "app") {
    return (window.location.href = iosStore);
  }

  // Desktop: skip deep link, go straight to store
  if (!isIOS && !isAndroid) {
    window.location.href = iosStore;
    return;
  }

  // Mobile: try deep link, fall back to store if app isn't installed
  const storeUrl = isIOS ? iosStore : androidStore;
  const start = Date.now();
  window.location.href = "chower://home";

  setTimeout(() => {
    if (document.hidden || Date.now() - start > 2000) return;
    window.location.href = storeUrl;
  }, 1500);
};
